import { combineReducers } from '@reduxjs/toolkit'

import carrierProposalReducer from 'features/carrierProposal/reducer'
import rateTypeReducer from 'features/rateTypes/reducer'
import requestForProposalListReducer from 'features/requestForProposalList/reducer'
import userReducer from 'features/user/reducer'
import laneDetailReducer from 'features/lanes/reducer'
import carriersReducer from 'features/carriers/reducer'
import carrierInvitesReducer from 'features/carrierInvites/reducer'
import laneProposalsReducer from 'features/laneProposals/reducer'
import messagesReducer from 'features/message/reducer'

const rootReducer = combineReducers({
  carrierProposal: carrierProposalReducer,
  rateType: rateTypeReducer,
  requestForProposalList: requestForProposalListReducer,
  user: userReducer,
  laneDetail: laneDetailReducer,
  carriers: carriersReducer,
  carrierInvites: carrierInvitesReducer,
  laneProposals: laneProposalsReducer,
  messages: messagesReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
